import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative bg-[#1a1f2e] pt-24 pb-32 overflow-hidden border-b border-[#e2e2e2]">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative z-10 flex flex-col items-center text-center px-6 max-w-4xl mx-auto">
        {/* Hero Logo — centered */}
        <div className="mb-6">
          <img
            src="https://static.readdy.ai/image/74aaa5890e80b03ee640528edfaa25c4/2d85756bdda65ea39650f591d5a0b427.png?crop=tight"
            alt="Vantage Commercial Advisory"
            className="w-auto object-contain brightness-0 invert"
            style={{
              width: 'clamp(200px, 25vw, 320px)',
              maxWidth: '70vw',
              height: 'auto',
            }}
          />
        </div>

        <div className="w-32 h-px bg-white/20 mb-6"></div>

        <h1
          className="text-5xl font-light text-white mb-6 leading-tight"
          style={{ fontFamily: 'Crimson Text, serif' }}
        >
          Helping Commercial Trade Leaders Identify Hidden Margin Leakage and Strengthen Cash Flow Visibility
        </h1>

        <p className="text-lg text-white/70 font-light leading-relaxed mb-10 max-w-2xl">
          We partner with commercial mechanical, fire protection, and specialty trade contractors to quantify operational
          margin erosion and enhance enterprise value ahead of scale or transition.
        </p>

        <Link
          to="/contact"
          className="inline-flex items-center gap-3 bg-[#B8963E] text-white px-8 py-4 rounded-md font-medium hover:bg-[#A6862F] transition-colors cursor-pointer whitespace-nowrap text-[15px]"
        >
          <span>Request a Free Confidential Discussion</span>
          <i className="ri-arrow-right-line text-lg"></i>
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
